import AntIcon from "@/components/icons/AntIcon";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { Insurance } from "../../../../types";

interface Props {
  insurances: Insurance[];
  activeKeys: string[];
  onActiveKeysChange: (keys: string[]) => void;
}

export const InsurancesToggleAllButton = ({ insurances, activeKeys, onActiveKeysChange }: Props) => {
  const { t } = useTranslation();

  const insuranceIds = insurances.map((insurance) => insurance.id);
  const anyOpened = insuranceIds.some((id) => activeKeys.includes(id));

  return (
    <Button
      icon={<AntIcon type="arrows" />}
      size="small"
      onClick={() =>
        onActiveKeysChange(
          anyOpened
            ? activeKeys.filter((key) => !insuranceIds.includes(key))
            : [...activeKeys, ...insuranceIds.filter((id) => !activeKeys.includes(id))],
        )
      }
    >
      {anyOpened ? t("common.closeAll") : t("common.openAll")}
    </Button>
  );
};
